import { GetBoardingCertificateResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetBoardingCertificateResultModel } from './get-boarding-certificate-result.state';

/** StateDetailsActions */
const ACTION_SET = '[GetBoardingCertificateResult] set';
const ACTION_UPDATE = '[GetBoardingCertificateResult] update';
const ACTION_RESET = '[GetBoardingCertificateResult] reset';
const ACTION_FAIL = '[GetBoardingCertificateResult] fail';
const ACTION_CANCEL_REQUEST = '[GetBoardingCertificateResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetBoardingCertificateResult] set from api';
const ACTION_UPDATE_FROM_API = '[GetBoardingCertificateResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetBoardingCertificateResult = createAction(
  ACTION_SET,
  props<WithRequestId<GetBoardingCertificateResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetBoardingCertificateResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetBoardingCertificateResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetBoardingCertificateResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetBoardingCertificateResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetBoardingCertificateResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetBoardingCertificateResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetBoardingCertificateResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetBoardingCertificateResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetBoardingCertificateResponse>>()
);
